export default {
  bind() {
    // init
  },
  inserted(el, binding, vnode) {
    // 父节点存在，但不一定已被插入文档中
    console.log('v-click inserted', el, binding, vnode)
  },
  update() {
    // 所在组件的 VNode 更新时调用
  },
  componentUpdated() {
    // 指令所在组件的 VNode 及其子 VNode 全部更新后调用
  },
  unbind() {
    // 移除相关绑定
  },
}
